export default __webpack_public_path__ + "static/media/dia9.bcfb75a2.png";